import React from "react"
import styled from "@emotion/styled"
import { Box } from "@rebass/grid/emotion"

import SEO from "../../../../components/wild/global/seo"
import ProductOptionsSchema from "../../../../components/wild/global/productoptionsschema"
import MenATC from "../../../../components/wild/men/product/atcarea/menatc"
import Comparison from "../../../../components/wild/men/comparison/"
import Testimonial from "../../../../components/wild/men/results-video/results"
import RootCauses from "../../../../components/wild/men/product/rootcauses/pdp/rootcauses"
import Technology from "../../../../components/wild/men/product/technology/technology"
import Results from "../../../../components/wild/men/results/results"
import FaqContact from "../../../../components/wild/men/faq/faqcontact"
import References from "../../../../components/wild/global/references/references"

import { data } from "../../../../data/men/thinning-hair-growth-supplement"
import { meshProductDataV2 } from "../../../../utils/productloader"

const Wrapper = styled.div``

const Men = (props) => {
  const mageProducts = props.pageContext.products
  const meshedProductData = meshProductDataV2(mageProducts, data)

  return (
    <Wrapper>
      <SEO
        title={meshedProductData.seo.title}
        description={meshedProductData.seo.description}
      />
      <ProductOptionsSchema options={meshedProductData.atcAreaData.options} />
      <MenATC data={meshedProductData.atcAreaData} />
      <Comparison data={meshedProductData.comparison} />
      <Box pt={[16, null, 80, 64]} pb={[16, null, 8]}>
        <Testimonial data={data.testimonials} />
      </Box>
      <RootCauses data={meshedProductData.rootCauses} />
      <Technology data={meshedProductData.technology} />
      <Results data={meshedProductData.results} />
      <FaqContact data={meshedProductData.faqContact} />
      <References data={meshedProductData.references} />
    </Wrapper>
  )
}

export default Men
